import { defineComponent as Z, computed as o, ref as N, watch as j, createElementBlock as x, openBlock as p, createElementVNode as f, createCommentVNode as g, createBlock as D, normalizeClass as E, toDisplayString as b, createVNode as q, mergeProps as G, withModifiers as H, unref as J, withCtx as K } from "vue";
import Q from "../../icons/generated/IconPlus.vue2.js";
import { isEmpty as m } from "../../utils/isEmpty.js";
import { tw as i } from "../../utils/tailwind.js";
import ee from "../Document/Document.vue2.js";
import te from "../DocumentList/DocumentList.vue2.js";
import { IMAGE_FILE_PREVIEW_EXTENSIONS as ae, ERROR_EVENT as le } from "./InputFileUpload.constant.js";
import { hasValidExtension as z, getTotalFilesSize as ie } from "./InputFileUpload.helpers.js";
const oe = { class: "relative h-48" }, se = ["for"], re = ["id", "accept", "disabled", "multiple"], ne = ["id"], he = /* @__PURE__ */ Z({
  name: "RevInputFileUpload",
  inheritAttrs: !1,
  __name: "InputFileUpload",
  props: {
    modelValue: { default: () => [] },
    accept: { default: () => ["*"] },
    deleteAlternativeText: { default: "" },
    description: { default: "" },
    disabled: { type: Boolean, default: () => !1 },
    id: {},
    errors: { default: () => [] },
    labelEmpty: {},
    labelNotEmpty: { default: "" },
    maxFiles: { default: Number.POSITIVE_INFINITY },
    maxFileSize: { default: Number.POSITIVE_INFINITY },
    maxFilesSize: { default: Number.POSITIVE_INFINITY },
    minFileSize: { default: 0 },
    disableImagePreview: { type: Boolean, default: !1 },
    filePreviewDisplay: { default: "inline" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["errors", "update:modelValue"],
  setup(T, { emit: A }) {
    const e = T, v = A, C = o(() => !m(e.modelValue)), P = o(() => C.value && !m(e.labelNotEmpty) ? e.labelNotEmpty : e.labelEmpty), M = o(() => e.accept.join()), R = o(() => !m(e.description)), d = o(() => !m(e.errors)), $ = o(() => {
      if (d.value)
        return `${e.id}_error`;
    }), c = N([]);
    function k(t) {
      return new Promise((n, l) => {
        const a = new FileReader();
        a.onload = () => n(a.result), a.onerror = () => l(new Error(`Failed to read file: ${t.name}`)), a.readAsDataURL(t);
      });
    }
    j(
      () => e.modelValue,
      async (t) => {
        if (!t || !t.length) {
          c.value = [];
          return;
        }
        try {
          const n = await Promise.all(
            t.map(async (l, a) => ({
              file: l,
              previewUrl: await k(l),
              isImage: z(l, ae),
              key: `${l.name}_${l.size}_${a}`
            }))
          );
          c.value = n;
        } catch {
          c.value = [];
        }
      },
      { immediate: !0 }
    );
    const X = o(() => e.modelValue ? e.modelValue.length >= e.maxFiles : !1), s = o(() => e.disabled || X.value), L = o(() => [
      i`body-2 mt-8`,
      !d.value && !s.value && i`text-static-default-low`,
      d.value && !s.value && i`text-static-danger-hi`,
      s.value && i`text-static-default-low-disabled`
    ]), O = o(() => [
      i`peer body-1 absolute inset-0 items-center py-12 pl-12 pr-52`,
      /* In case of a lengthy label, hide the rest of the label under an ellipsis. */
      i`inline max-w-full truncate`,
      s.value ? i`text-action-default-hi-disabled cursor-default` : i`text-action-default-hi cursor-pointer`
    ]), U = o(() => [
      i`rounded-sm flex size-full items-center justify-end border border-solid`,
      i`motion-safe:transition-colors motion-safe:duration-200`,
      !s.value && i`bg-static-default-low peer-hover:bg-static-default-low-hover`,
      !d.value && !s.value && i`border-action-default-low focus-within:border-action-default-low-focus focus-within:outline-default-low`,
      d.value && !s.value && i`border-action-danger-low focus-within:border-action-danger-low-focus focus-within:outline-danger-low`,
      s.value && i`bg-static-default-low-disabled border-action-default-low-disabled`
    ]), B = o(() => e.maxFiles > 1), h = N(null);
    function W(t) {
      const l = t.target.files, a = [];
      let u = [...e.modelValue];
      Array.from(l).forEach((r) => {
        const F = ie([...u, r]), w = F <= e.maxFilesSize;
        w || a.push({
          meta: { totalFilesSize: F },
          type: "MAX_FILES_SIZE_EXCEEDED"
        });
        const I = u.length < e.maxFiles;
        I || a.push({
          meta: { filename: r.name },
          type: "MAX_FILES_EXCEEDED"
        });
        const y = r.size < e.maxFileSize;
        y || a.push({
          meta: { filename: r.name },
          type: "MAX_FILE_SIZE_EXCEEDED"
        });
        const V = e.minFileSize < r.size;
        V || a.push({
          meta: { filename: r.name },
          type: "MIN_FILE_SIZE_NOT_EXCEEDED"
        });
        const S = z(r, e.accept);
        S || a.push({
          meta: { filename: r.name },
          type: "WRONG_FILE_EXTENSION"
        }), w && I && y && V && S && (u = [...u, r]);
      }), m(a) || v(le, a), v("update:modelValue", u);
      const _ = h.value;
      _ && (_.value = "");
    }
    function Y(t) {
      const n = [
        ...e.modelValue.slice(0, t),
        ...e.modelValue.slice(t + 1)
      ];
      v("update:modelValue", n);
    }
    return (t, n) => (p(), x("div", null, [
      f("div", oe, [
        f("label", {
          class: E(O.value),
          for: t.id
        }, b(P.value) + b(t.required ? " *" : ""), 11, se),
        f("div", {
          class: E(U.value)
        }, [
          f("input", G(t.$attrs, {
            id: t.id,
            ref_key: "input",
            ref: h,
            accept: M.value,
            class: "peer absolute z-[-1] opacity-0",
            disabled: s.value,
            multiple: B.value,
            type: "file",
            onChange: H(W, ["prevent"])
          }), null, 16, re),
          q(J(Q), {
            "aria-hidden": "true",
            class: "text-static-default-low ml-16 mr-12 h-32 peer-disabled:text-static-default-low-disabled"
          })
        ], 2)
      ]),
      R.value ? (p(), x("p", {
        key: 0,
        id: $.value,
        class: E(L.value)
      }, b(t.description), 11, ne)) : g("", !0),
      c.value.length ? (p(), D(te, {
        key: 1,
        class: "max-w-[912px]",
        documents: c.value,
        variant: e.filePreviewDisplay
      }, {
        item: K(({ document: l, index: a }) => [
          (p(), D(ee, {
            key: l.key,
            deletable: "",
            "delete-button-aria-label": e.deleteAlternativeText,
            name: l.file.name,
            thumbnail: l.isImage && !e.disableImagePreview,
            url: l.previewUrl,
            onDelete: (u) => Y(a)
          }, null, 8, ["delete-button-aria-label", "name", "thumbnail", "url", "onDelete"]))
        ]),
        _: 1
      }, 8, ["documents", "variant"])) : g("", !0)
    ]));
  }
});
export {
  he as default
};
